import { makeAutoObservable } from 'mobx';
class ApiStore {
    apiDataSource = {};
    constructor() {
        makeAutoObservable(this);
    }
    setApiDataSource = (name, value) => {
        this.apiDataSource = {
            ...this.apiDataSource,
            [name]: value,
        };
    };
}
export default new ApiStore();
